(() => {
  if (window.__NHIP_CUSTOM_MODERN_V5) return;
  window.__NHIP_CUSTOM_MODERN_V5 = true;

  const SEARCH_URL = 'https://hook.us2.make.com/5u4hyf1rb7jghatmwalgrhvbd0b6hy5w';
  const ACCEPT_URL = 'https://hook.us2.make.com/2mxybqctnxdeyqb5yoda9vax3odqu21d';

  const COVERAGE = window.NHIP_COVERAGE;
  if (!COVERAGE) return;

  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[char]));

  const parseDays = (label) => {
    const match = String(label || '').match(/\d+/);
    return match ? Number(match[0]) : NaN;
  };

  const normalizeTier = (tier) => String(tier || 'REGULAR').toUpperCase();

  const tierLabel = (tier) =>
    normalizeTier(tier) === 'PREMIUM' ? 'Premium' : 'Regular';

  const customerDataLabel = (option) => {
    const planType = String(option?.plan_type || '').toUpperCase();
    if (planType.includes('UNLIMITED')) {
      return String(option?.display_label || 'Unlimited');
    }
    const gb = Number(option?.data_gb);
    if (Number.isFinite(gb) && gb > 0 && gb < 1) {
      return `${Math.round(gb * 1024)}MB`;
    }
    return String(
      option?.display_label || (Number.isFinite(gb) ? `${gb}GB` : '')
    );
  };

  function isCustomTrigger(el) {
    if (!el) return false;
    if (el.closest('[id$="__rich_text_33GHEx"]')) return true;
    if (el.closest('.nhip-product-custom-quote-cta')) return true;
    const text = String(el.textContent || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
    return text.includes('custom') && text.includes('quote');
  }

  function buttonMatch(target) {
    const el = target && target.closest ? target.closest('a,button') : null;
    return isCustomTrigger(el) ? el : null;
  }

  function setCustomButtonActive(el) {
    if (!el) return;
    el.removeAttribute('aria-disabled');
    el.removeAttribute('disabled');
    if ('disabled' in el) el.disabled = false;
    el.classList.remove('disabled');
    el.style.setProperty('cursor', 'pointer', 'important');
  }

  function ensureStyles() {
    if (document.getElementById('nhip-custom-modern-style')) return;

    const style = document.createElement('style');
    style.id = 'nhip-custom-modern-style';

    style.textContent = `
      #nhip-custom-modal{display:none;position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,.55);padding:18px;overflow:auto;align-items:flex-start;justify-content:center}
      #nhip-custom-modal.nhip-open{display:flex}
      #nhip-custom-modal .nhip-panel{background:#fff;color:#111;width:min(760px,100%);margin:5vh auto 40px;padding:22px;border-radius:10px;box-shadow:0 24px 70px rgba(0,0,0,.3);font-family:inherit;max-height:90vh;overflow-y:auto;overscroll-behavior:contain;scrollbar-gutter:stable}
      #nhip-custom-modal .nhip-head{display:flex;justify-content:space-between;gap:18px;align-items:flex-start}
      #nhip-custom-modal h2{font-size:22px;margin:0 0 6px}
      #nhip-custom-modal p{margin:6px 0 12px}
      #nhip-custom-modal .nhip-close{border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer;padding:0 4px}
      #nhip-custom-modal .nhip-field{margin:12px 0}
      #nhip-custom-modal label{display:block;font-weight:700;margin-bottom:5px}
      #nhip-custom-modal select,#nhip-custom-modal input{width:100%;box-sizing:border-box;padding:10px 11px;border:1px solid #bbb;border-radius:4px;background:#fff;color:#111;font:inherit}
      #nhip-custom-modal .nhip-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}
      #nhip-custom-modal .nhip-help{border:1px solid #d7d7d7;background:#f7f7f7;border-radius:5px;padding:10px 12px;font-size:13px;line-height:1.35;margin:12px 0}
      #nhip-custom-modal .nhip-actions{display:flex;gap:10px;flex-wrap:wrap;margin:14px 0}
      #nhip-custom-modal .nhip-btn{appearance:none;border:1px solid #111;background:#111;color:#fff;padding:10px 16px;font-weight:700;cursor:pointer;font:inherit}
      #nhip-custom-modal .nhip-btn.secondary{background:#fff;color:#111}
      #nhip-custom-modal .nhip-btn:disabled{opacity:.45;cursor:not-allowed}
      #nhip-custom-modal .nhip-result{border-top:1px solid #ddd;margin-top:16px;padding-top:16px}
      #nhip-custom-modal .nhip-card{border:1px solid #cfcfcf;border-radius:5px;padding:12px 14px;margin:9px 0;cursor:pointer;background:#fff;transition:border-color .15s,box-shadow .15s,background .15s}
      #nhip-custom-modal .nhip-card:hover{border-color:#777}
      #nhip-custom-modal .nhip-card[aria-checked="true"]{border-color:#111;box-shadow:0 0 0 1px #111;background:#fafafa}
      #nhip-custom-modal .nhip-card-title-row{display:flex;align-items:baseline;justify-content:space-between;gap:12px}
      #nhip-custom-modal .nhip-card-title{font-weight:800}
      #nhip-custom-modal .nhip-card-meta{
        font-size:14px;
        color:#333;
        margin-top:3px;
        font-weight:500;
      }
      #nhip-custom-modal .nhip-card-price{font-weight:800;font-size:16px;margin-top:0;white-space:nowrap}
      #nhip-custom-modal #nhip-options{box-sizing:border-box;max-height:min(540px,60dvh);overflow-y:auto;overscroll-behavior:contain;scrollbar-gutter:stable;border:1px solid #ddd;border-radius:7px;padding:6px}
      #nhip-custom-modal .nhip-status{font-weight:700;margin:12px 0}
      #nhip-custom-modal .nhip-selection-bar{position:sticky;top:0;z-index:6;background:#fff;border:1px solid #d7d7d7;border-radius:5px;box-shadow:0 8px 18px rgba(0,0,0,.08);padding:10px 12px;margin:0 0 12px;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap}
      #nhip-custom-modal .nhip-selection-bar .nhip-status{margin:0}
      #nhip-custom-modal .nhip-selection-bar{position:sticky;top:0;z-index:6;background:#fff;border:1px solid #d7d7d7;border-radius:5px;box-shadow:0 8px 18px rgba(0,0,0,.08);padding:10px 12px;margin:0 0 12px;display:none;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap}
      #nhip-custom-modal .nhip-selection-bar.nhip-show{display:flex}
      #nhip-custom-modal .nhip-selection-bar .nhip-status{margin:0}
      #nhip-custom-modal .nhip-confirm-bar{position:sticky;top:0;z-index:7;background:#fff;border:1px solid #d7d7d7;border-radius:5px;box-shadow:0 8px 18px rgba(0,0,0,.10);padding:10px 12px;margin:0 0 12px;display:flex;gap:10px;align-items:center;flex-wrap:wrap;box-sizing:border-box}
      #nhip-custom-modal .nhip-note{font-size:12px;color:#666;margin-top:12px}
      #nhip-custom-modal .nhip-scroll-hint{font-size:12px;color:#555;margin:0 0 8px}
      #nhip-custom-modal .nhip-error{font-weight:700;color:#9a1b1b}

      @media(min-width:641px){
        #nhip-custom-modal{padding:10px}
        #nhip-custom-modal .nhip-panel{width:min(720px,100%);margin:1.5vh auto 16px;padding:14px 18px;max-height:96vh}
        #nhip-custom-modal h2{font-size:20px;margin:0 0 3px}
        #nhip-custom-modal p{margin:3px 0 7px}
        #nhip-custom-modal .nhip-field{margin:7px 0}
        #nhip-custom-modal label{margin-bottom:3px}
        #nhip-custom-modal select,#nhip-custom-modal input{padding:7px 9px}
        #nhip-custom-modal .nhip-grid{gap:8px}
        #nhip-custom-modal .nhip-help{padding:7px 9px;margin:7px 0;font-size:12px;line-height:1.25}
        #nhip-custom-modal .nhip-actions{margin:7px 0;gap:8px}
        #nhip-custom-modal .nhip-btn{padding:8px 13px}
        #nhip-custom-modal .nhip-result{margin-top:8px;padding-top:8px}
        #nhip-custom-modal .nhip-card{padding:8px 10px;margin:5px 0}
        #nhip-custom-modal .nhip-card-meta{font-size:12px}
        #nhip-custom-modal .nhip-card-price{font-size:15px}
        #nhip-custom-modal .nhip-status{margin:6px 0}
        #nhip-custom-modal .nhip-note{font-size:11px;line-height:1.25;margin-top:6px}
      }

      @media(max-width:640px){
        #nhip-custom-modal{padding:6px}
        #nhip-custom-modal .nhip-panel{margin:1vh auto 10px;padding:12px;max-height:94dvh}
        #nhip-custom-modal h2{font-size:19px;margin-bottom:4px}
        #nhip-custom-modal p{margin:4px 0 8px}
        #nhip-custom-modal .nhip-field{margin:8px 0}
        #nhip-custom-modal label{margin-bottom:3px;font-size:14px}
        #nhip-custom-modal select,#nhip-custom-modal input{padding:8px 9px}
        #nhip-custom-modal .nhip-grid{grid-template-columns:1fr 1fr;gap:8px}
        #nhip-custom-modal .nhip-grid label{font-size:13px;line-height:1.3;min-height:0}
        #nhip-custom-modal .nhip-note{font-size:11px;line-height:1.3}
        #nhip-custom-modal .nhip-help{display:none}
        #nhip-custom-modal .nhip-actions{margin:10px 0;gap:8px}
        #nhip-custom-modal .nhip-btn{padding:9px 12px;font-size:14px}
        #nhip-custom-modal .nhip-card{padding:10px 12px;margin:7px 0}
        #nhip-custom-modal .nhip-confirmed{margin-top:8px;padding-top:8px}
        #nhip-custom-modal .nhip-confirmed h3{margin:4px 0 8px}
        #nhip-custom-modal .nhip-confirmed p{margin:3px 0 6px}
        #nhip-custom-modal .nhip-confirmed .nhip-confirm-bar{padding:8px 10px;margin:0 0 6px;gap:8px}
      }

      #nhip-custom-modal .nhip-tier-help-mobile{display:none}
      #nhip-custom-modal .nhip-panel{max-height:calc(100dvh - 92px)}

      @media(max-width:640px){
        #nhip-custom-modal .nhip-tier-help-desktop{display:none}
        #nhip-custom-modal .nhip-tier-help-mobile{display:block;margin:2px 0 8px;font-size:12px}
        #nhip-custom-modal .nhip-tier-help-mobile summary{cursor:pointer;font-weight:700}
        #nhip-custom-modal .nhip-tier-help-mobile .nhip-note{margin:6px 0}
        #nhip-custom-modal .nhip-grid .nhip-field{display:flex;flex-direction:column}
        #nhip-custom-modal .nhip-grid label{min-height:2.6em;display:flex;align-items:flex-end}
      }

      #nhip-custom-modal .nhip-card-title,
      #nhip-custom-modal .nhip-card-meta,
      #nhip-custom-modal .nhip-card-network,
      #nhip-custom-modal .nhip-card-price,
      #nhip-custom-modal .nhip-card-title strong,
      #nhip-custom-modal .nhip-card-meta strong,
      #nhip-custom-modal .nhip-card-network strong,
      #nhip-custom-modal .nhip-card-price strong{
        font-family:inherit;
        font-size:14px;
        font-weight:700;
        color:#111;
        line-height:1.4;
      }

      #nhip-custom-modal .nhip-card-network{
        flex:1;
        min-width:140px;
        text-align:center;
        margin-top:3px;
        overflow-wrap:anywhere;
      }

      @media(max-width:640px){
        #nhip-custom-modal .nhip-card-title-row{
          flex-wrap:wrap;
          row-gap:3px;
        }
        #nhip-custom-modal .nhip-card-title{
          flex:1;
          min-width:0;
          overflow-wrap:anywhere;
        }
        #nhip-custom-modal .nhip-card-network{
          flex:0 0 100%;
          min-width:0;
          order:3;
          text-align:left;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function createModal() {
    if (document.getElementById('nhip-custom-modal')) {
      return document.getElementById('nhip-custom-modal');
    }

    ensureStyles();

    const modal = document.createElement('div');
    modal.id = 'nhip-custom-modal';

    const tierDescription = '<strong>Regular:</strong> Standard qualified connectivity on the plan’s standard supported network(s). <strong>Premium:</strong> An upgraded carrier option with a different supported network mix. In China, Premium uses China Telecom + China Unicom, while Regular uses China Mobile—giving Premium two supported carrier networks instead of one. Actual 4G/5G availability varies by location and device.';

    modal.innerHTML = `
      <div class="nhip-panel" role="dialog" aria-modal="true" aria-labelledby="nhip-custom-title">
        <div class="nhip-head">
          <div>
            <h2 id="nhip-custom-title">Get a Custom eSIM Quote</h2>
            <p>Tell us what you need. We’ll show all qualified NHIP options.</p>
          </div>
          <button type="button" class="nhip-close" id="nhip-custom-close" aria-label="Close">×</button>
        </div>

        <div class="nhip-field">
          <label for="nhip-q-destination">Destination</label>
          <select id="nhip-q-destination">
            <option value="">Choose destination</option>
            ${`<optgroup label="Regional & Global">${COVERAGE.regions.map((entry) => `<option value="${esc(entry.name)}" data-scope="${entry.type}" data-code="${esc(entry.code)}">${esc(entry.name)}</option>`).join('')}</optgroup><optgroup label="Countries & Territories">${COVERAGE.countries.slice().sort((a,b) => a.name.localeCompare(b.name)).map((entry) => `<option value="${esc(entry.name)}" data-scope="${entry.type}" data-code="${esc(entry.code)}">${esc(entry.name)}</option>`).join('')}</optgroup>`}
          </select>
        </div>

        <div class="nhip-field">
          <label for="nhip-q-tier">Service Tier</label>
          <select id="nhip-q-tier">
            <option value="REGULAR">Regular</option>
            <option value="PREMIUM">Premium</option>
            <option value="*" selected>* Regular &amp; Premium</option>
          </select>
          <div class="nhip-note nhip-tier-help-desktop" style="font-weight:700;color:#333;line-height:1.45">${tierDescription}</div>
          <details class="nhip-tier-help-mobile">
            <summary>About Regular and Premium</summary>
            <div class="nhip-note">${tierDescription}</div>
          </details>
        </div>

        <div class="nhip-grid">
          <div class="nhip-field">
            <label for="nhip-q-data">Data needed (MB, GB, U, or *)</label>
            <input id="nhip-q-data" type="text" inputmode="text" value="*" placeholder="Example: 100MB, 5GB, 100, U, Unlimited, or *">
          </div>
          <div class="nhip-field">
            <label for="nhip-q-validity">Validity (days)</label>
            <input id="nhip-q-validity" type="text" inputmode="numeric" value="" placeholder="1–365" required>
          </div>
        </div>

        <div class="nhip-help">
          <strong>Not sure which plan you need?</strong><br><br>
          • For fixed data, enter MB or GB, such as <strong>100MB</strong> or <strong>5GB</strong>.<br>
          • If you enter only a number, such as <strong>100</strong>, we’ll search both <strong>100MB</strong> and <strong>100GB</strong>.<br>
          • For unlimited data, enter <strong>U</strong>, <strong>UNL</strong>, <strong>Unlimited</strong>, or any entry beginning with <strong>“Un”</strong>.<br>
          • For unknown Data, enter <strong>*</strong>.<br>
          • For Validity, enter a whole number from <strong>1 to 365</strong>.<br><br>
          Fixed-data results are compared across our qualified connectivity pool.
        </div>

        <div class="nhip-actions">
          <button type="button" id="nhip-q-find" class="nhip-btn">GET MY eSIM QUOTE</button>
          <button type="button" id="nhip-q-cancel" class="nhip-btn secondary">NO THANKS</button>
        </div>

        <div id="nhip-custom-result" class="nhip-result" aria-live="polite"></div>
      </div>`;

    document.body.appendChild(modal);
    return modal;
  }

  const resultEl = () => document.getElementById('nhip-custom-result');

  function setResult(html) {
    const root = resultEl();
    if (root) root.innerHTML = html;
  }

  function openModal() {
    const modal = createModal();
    const panel = modal.querySelector('.nhip-panel');
    if (panel) panel.scrollTop = 0;
    modal.classList.add('nhip-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => document.getElementById('nhip-q-destination')?.focus(), 0);
  }

  function closeModal() {
    const modal = document.getElementById('nhip-custom-modal');
    if (!modal) return;
    const root = resultEl();
    const panel = modal.querySelector('.nhip-panel');
    if (root && panel) panel.appendChild(root);
    modal.classList.remove('nhip-open');
    document.body.style.overflow = '';
  }

  function expandProductDestinations() {
    if (!location.pathname.startsWith('/products/regional-global-esim')) return;

    const select = document.querySelector('select[name="options[Destination]"]');
    if (!select || select.dataset.nhipCoverageExpanded === 'true') return;

    const existing = new Set(
      Array.from(select.options, (option) => option.value.toLowerCase())
    );

    const missing = COVERAGE.entries.filter(
      (entry) => !existing.has(entry.name.toLowerCase())
    );

    if (!missing.length) return;

    const group = document.createElement('optgroup');
    group.label = 'More destinations — custom quote';

    missing.sort((a, b) => a.name.localeCompare(b.name)).forEach((entry) => {
      const option = document.createElement('option');
      option.value = entry.name;
      option.textContent = entry.name;
      option.dataset.nhipCustomDestination = 'true';
      group.appendChild(option);
    });

    select.appendChild(group);

    const note = document.createElement('p');
    note.className = 'nhip-product-destination-note';
    note.textContent = 'More destinations open a custom quote. Plan availability is checked before purchase.';
    note.style.cssText = 'font-size:12px;line-height:1.4;margin:5px 0 0;color:#555';
    select.closest('.product-form__input')?.appendChild(note);

    let readyDestination = select.value;

    select.addEventListener('change', (event) => {
      const option = select.selectedOptions[0];

      if (!option?.dataset.nhipCustomDestination) {
        readyDestination = select.value;
        return;
      }

      event.stopImmediatePropagation();
      event.stopPropagation();

      const destination = option.value;
      select.value = readyDestination;

      openModal();

      const quoteDestination = document.getElementById('nhip-q-destination');
      if (quoteDestination) quoteDestination.value = destination;
    }, true);

    select.dataset.nhipCoverageExpanded = 'true';
  }

  async function post(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(payload),
      cache: 'no-store'
    });

    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.json();
  }
  function requestValues() {
    const destination = document.getElementById('nhip-q-destination')?.value || '';
    const tier = document.getElementById('nhip-q-tier')?.value || '*';
    const data = String(document.getElementById('nhip-q-data')?.value || '*').trim();
    const validity = String(document.getElementById('nhip-q-validity')?.value || '').trim();

    return {
      destination,
      country_code: COVERAGE.find(destination)?.code || '',
      scope: COVERAGE.find(destination)?.type || '',
      service_tier: tier,
      data_request: data || '*',
      validity_request: validity
    };
  }
    function isWildcard(value) {
    return String(value || '').trim() === '*';
  }

  function dataRequestUnit(value) {
    const normalized = String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');

    if (normalized.endsWith('MB')) return 'MB';
    if (normalized.endsWith('GB')) return 'GB';
    return 'BOTH';
  }

  function numericValue(value) {
    const number = Number(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) && number > 0 ? number : NaN;
  }

  function matchesDataRequest(option, value) {
    const requested = numericValue(value);
    const gb = Number(option?.data_gb);

    if (!Number.isFinite(requested) || !Number.isFinite(gb)) return false;

    const mbMatch = Math.round(gb * 1024) === requested;
    const gbMatch = gb === requested;
    const unit = dataRequestUnit(value);

    if (unit === 'MB') return mbMatch;
    if (unit === 'GB') return gbMatch;
    return mbMatch || gbMatch;
  }

  function validityValue(value) {
    const normalized = String(value || '').trim();

    if (!/^\d+$/.test(normalized)) return NaN;

    const number = Number(normalized);

    return Number.isSafeInteger(number) && number >= 1 && number <= 365
      ? number
      : NaN;
  }

  function isUnlimitedInput(value) {
    const normalized = String(value || '').trim().toLowerCase();

    return normalized === 'u' ||
      normalized === 'unl' ||
      normalized.startsWith('un');
  }

  function quotePlanType(option) {
    return String(option?.plan_type || '').toUpperCase().includes('UNLIMITED')
      ? 'UNLIMITED'
      : 'FIXED';
  }

  function unlimitedModelForOption(option) {
    const planType = String(option?.plan_type || '').toUpperCase();
    const label = String(option?.display_label || '').toLowerCase();

    if (planType === 'TRUE_UNLIMITED' || label.includes('true unlimited')) {
      return 'TRUE_UNLIMITED';
    }

    if (planType === 'UNLIMITED') {
      if (label.includes('512 kbps')) return 'DAILY_QUOTA_FUP_512KBPS';
      if (label.includes('500 kbps')) return 'DAILY_QUOTA_FUP_500KBPS';
      if (label.includes('1 mbps')) return 'DAILY_QUOTA_FUP_1MBPS';
      return 'DAILY_QUOTA';
    }

    return 'NONE';
  }

  function restoreResultPlacement() {
    const root = resultEl();
    const panel = document.querySelector('#nhip-custom-modal .nhip-panel');
    const actions = panel?.querySelector('.nhip-actions');

    if (root && actions) actions.insertAdjacentElement('afterend', root);
  }

  function sortOptions(options, requested) {
    const validityNumber = validityValue(requested.validity_request);
    const dataNumber = numericValue(requested.data_request);

    return [...options].sort((a, b) => {
      const aDays = parseDays(a.validity_label);
      const bDays = parseDays(b.validity_label);
      const aData = Number(a.data_gb);
      const bData = Number(b.data_gb);

      if (Number.isFinite(validityNumber)) {
        if (aData !== bData) return aData - bData;
        if (aDays !== bDays) return aDays - bDays;
      } else if (Number.isFinite(dataNumber)) {
        if (aDays !== bDays) return aDays - bDays;
        if (aData !== bData) return aData - bData;
      } else {
        if (aDays !== bDays) return aDays - bDays;
        if (aData !== bData) return aData - bData;
      }

      return normalizeTier(a.service_tier)
        .localeCompare(normalizeTier(b.service_tier));
    });
  }

  function optionIsUnlimited(option) {
    return String(option?.plan_type || '').toUpperCase().includes('UNLIMITED');
  }

  function customerOfferKey(option) {
    const tier = normalizeTier(option?.service_tier);
    const days = parseDays(option?.validity_label);
    const planType = optionIsUnlimited(option) ? 'UNLIMITED' : 'FIXED';
    const gb = Number(option?.data_gb);

    const dataKey = planType === 'UNLIMITED'
      ? unlimitedModelForOption(option)
      : (Number.isFinite(gb) ? Math.round(gb * 1024) : 'NA');

    // Keep separate offers when their identity, networks, or price differ.
    const offerKey = String(option?.offer_key || '').trim();
    const coverageKey = String(option?.coverage_key || '').trim();
    const provider = String(option?.provider || '').trim().toUpperCase();
    const packageId = String(option?.provider_package_id || '').trim();
    const packageCode = String(option?.provider_package_code || '').trim();

    const networks = String(option?.network_summary || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

    const price = Number(option?.price_usd);

    const priceKey = Number.isFinite(price)
      ? price
      : String(option?.price_usd || '');

    return JSON.stringify([
      tier,
      days,
      planType,
      dataKey,
      offerKey,
      coverageKey,
      provider,
      packageId,
      packageCode,
      networks,
      priceKey
    ]);
  }

  function dedupeEquivalentOffers(options) {
    const uniqueByKey = new Map();

    options.forEach((option) => {
      const key = customerOfferKey(option);

      // Remove only identical copies; never pick one offer by cheapest price.
      if (!uniqueByKey.has(key)) uniqueByKey.set(key, option);
    });

    return Array.from(uniqueByKey.values());
  }

  function exactOptions(options, requested) {
    const dataWildcard = isWildcard(requested.data_request);
    const validityWildcard = isWildcard(requested.validity_request);
    const unlimitedRequested = isUnlimitedInput(requested.data_request);
    const dataNumber = numericValue(requested.data_request);
    const validityNumber = validityValue(requested.validity_request);

    return dedupeEquivalentOffers(options.filter((option) => {
      const optionDays = parseDays(option?.validity_label);

      if (!validityWildcard && optionDays !== validityNumber) return false;

      if (unlimitedRequested) {
        return optionIsUnlimited(option);
      }

      if (dataWildcard) {
        return !optionIsUnlimited(option);
      }

      if (Number.isFinite(dataNumber)) {
        return (
          !optionIsUnlimited(option) &&
          matchesDataRequest(option, requested.data_request)
        );
      }

      return false;
    }));
  }

  function fixedPreferenceScore(option, requested) {
    const requestedData = numericValue(requested.data_request);
    const gb = Number(option?.data_gb);

    if (!Number.isFinite(gb)) return Number.POSITIVE_INFINITY;

    if (Number.isFinite(requestedData) && !isWildcard(requested.data_request)) {
      const unit = dataRequestUnit(requested.data_request);

      if (unit === 'MB') {
        return Math.abs(Math.round(gb * 1024) - requestedData);
      }

      if (unit === 'GB') {
        return Math.abs(gb - requestedData);
      }

      return Math.min(
        Math.abs(Math.round(gb * 1024) - requestedData),
        Math.abs(gb - requestedData)
      );
    }

    return gb;
  }

  function curateNearbyFallback(options, requested, limit = 7) {
    const requestedDays = validityValue(requested.validity_request);

    if (!Number.isFinite(requestedDays)) {
      return [];
    }

    const eligible = dedupeEquivalentOffers(
      options.filter((option) => {
        const days = parseDays(option?.validity_label);
        return Number.isFinite(days) && days >= requestedDays && days <= 365;
      })
    );

    if (!eligible.length) {
      return [];
    }

    const durations = Array.from(
      new Set(
        eligible
          .map((option) => parseDays(option?.validity_label))
          .filter(Number.isFinite)
      )
    )
      .sort((a, b) => a - b)
      .slice(0, 3);

    const selected = [];
    const selectedKeys = new Set();

    const add = (option) => {
      if (!option || selected.length >= limit) return;

      const key = customerOfferKey(option);

      if (selectedKeys.has(key)) return;

      selectedKeys.add(key);
      selected.push(option);
    };

    // First pass: one useful fixed plan and one Unlimited plan from each
    // of the three nearest longer-validity buckets.
    durations.forEach((days) => {
      const bucket = eligible.filter(
        (option) => parseDays(option?.validity_label) === days
      );

      const fixed = bucket
        .filter((option) => !optionIsUnlimited(option))
        .sort((a, b) => {
          const preference =
            fixedPreferenceScore(a, requested) - fixedPreferenceScore(b, requested);

          if (preference) return preference;

          const aPrice = Number(a?.price_usd);
          const bPrice = Number(b?.price_usd);

          if (
            Number.isFinite(aPrice) &&
            Number.isFinite(bPrice) &&
            aPrice !== bPrice
          ) {
            return aPrice - bPrice;
          }

          return Number(a?.data_gb) - Number(b?.data_gb);
        });

      const unlimited = bucket
        .filter(optionIsUnlimited)
        .sort((a, b) => {
          const aPrice = Number(a?.price_usd);
          const bPrice = Number(b?.price_usd);

          if (
            Number.isFinite(aPrice) &&
            Number.isFinite(bPrice) &&
            aPrice !== bPrice
          ) {
            return aPrice - bPrice;
          }

          return unlimitedModelForOption(a)
            .localeCompare(unlimitedModelForOption(b));
        });

      add(fixed[0]);
      add(unlimited[0]);
    });

    // Second pass: fill remaining slots with distinct useful offers from
    // the same nearest duration buckets, closest duration first.
    const remaining = eligible
      .filter((option) => durations.includes(parseDays(option?.validity_label)))
      .sort((a, b) => {
        const aDays = parseDays(a?.validity_label);
        const bDays = parseDays(b?.validity_label);

        if (aDays !== bDays) return aDays - bDays;

        const aUnlimited = optionIsUnlimited(a);
        const bUnlimited = optionIsUnlimited(b);

        if (aUnlimited !== bUnlimited) return aUnlimited ? 1 : -1;

        if (!aUnlimited && !bUnlimited) {
          const preference =
            fixedPreferenceScore(a, requested) - fixedPreferenceScore(b, requested);

          if (preference) return preference;
        }

        const aPrice = Number(a?.price_usd);
        const bPrice = Number(b?.price_usd);

        if (
          Number.isFinite(aPrice) &&
          Number.isFinite(bPrice) &&
          aPrice !== bPrice
        ) {
          return aPrice - bPrice;
        }

        return 0;
      });

    remaining.forEach(add);

    return selected.slice(0, limit).sort((a, b) => {
      const aDays = parseDays(a?.validity_label);
      const bDays = parseDays(b?.validity_label);

      if (aDays !== bDays) return aDays - bDays;

      const aUnlimited = optionIsUnlimited(a);
      const bUnlimited = optionIsUnlimited(b);

      if (aUnlimited !== bUnlimited) return aUnlimited ? 1 : -1;

      if (!aUnlimited && !bUnlimited) {
        const aData = Number(a?.data_gb);
        const bData = Number(b?.data_gb);

        if (
          Number.isFinite(aData) &&
          Number.isFinite(bData) &&
          aData !== bData
        ) {
          return aData - bData;
        }
      }

      const tierCompare = normalizeTier(a?.service_tier)
        .localeCompare(normalizeTier(b?.service_tier));

      if (tierCompare) return tierCompare;

      const aPrice = Number(a?.price_usd);
      const bPrice = Number(b?.price_usd);

      if (
        Number.isFinite(aPrice) &&
        Number.isFinite(bPrice) &&
        aPrice !== bPrice
      ) {
        return aPrice - bPrice;
      }

      return 0;
    });
  }

  function filteredOptions(options, requested) {
    const exact = exactOptions(options, requested);

    if (exact.length) {
      return {
        items: exact,
        exact: true,
        fallback: false
      };
    }

    return {
      items: [],
      exact: false,
      fallback: true
    };
  }

  function curateOptions(options) {
    const ranked = options.map((candidate, candidateIndex) => {
      const candidatePrice = Number(candidate.price_usd);
      const candidateData = Number(candidate.data_gb);
      const candidateDays = parseDays(candidate.validity_label);

      const dominated =
        Number.isFinite(candidatePrice) &&
        Number.isFinite(candidateData) &&
        Number.isFinite(candidateDays) &&
        options.some((other, otherIndex) => {
          if (otherIndex === candidateIndex) return false;

          if (
            normalizeTier(other.service_tier) !==
            normalizeTier(candidate.service_tier)
          ) {
            return false;
          }

          if (
            String(other.plan_type || 'FIXED').toUpperCase() !==
            String(candidate.plan_type || 'FIXED').toUpperCase()
          ) {
            return false;
          }

          const otherPrice = Number(other.price_usd);
          const otherData = Number(other.data_gb);
          const otherDays = parseDays(other.validity_label);

          if (
            !Number.isFinite(otherPrice) ||
            !Number.isFinite(otherData) ||
            !Number.isFinite(otherDays)
          ) {
            return false;
          }

          const noWorse =
            otherData >= candidateData &&
            otherDays >= candidateDays &&
            otherPrice <= candidatePrice;

          const strictlyBetter =
            otherData > candidateData ||
            otherDays > candidateDays ||
            otherPrice < candidatePrice;

          return noWorse && strictlyBetter;
        });

      return {candidate, dominated, candidateIndex};
    });

    return ranked.sort((a, b) => {
      const aPrice = Number(a.candidate.price_usd);
      const bPrice = Number(b.candidate.price_usd);
      const aValidPrice = Number.isFinite(aPrice) && aPrice > 0;
      const bValidPrice = Number.isFinite(bPrice) && bPrice > 0;

      if (aValidPrice && bValidPrice && aPrice !== bPrice) {
        return aPrice - bPrice;
      }

      if (aValidPrice !== bValidPrice) return aValidPrice ? -1 : 1;
      if (a.dominated !== b.dominated) return a.dominated ? 1 : -1;

      const aDays = parseDays(a.candidate.validity_label);
      const bDays = parseDays(b.candidate.validity_label);

      if (
        Number.isFinite(aDays) &&
        Number.isFinite(bDays) &&
        aDays !== bDays
      ) {
        return aDays - bDays;
      }

      if (Number.isFinite(aDays) !== Number.isFinite(bDays)) {
        return Number.isFinite(aDays) ? -1 : 1;
      }

      const aData = Number(a.candidate.data_gb);
      const bData = Number(b.candidate.data_gb);

      if (
        Number.isFinite(aData) &&
        Number.isFinite(bData) &&
        aData !== bData
      ) {
        return aData - bData;
      }

      if (Number.isFinite(aData) !== Number.isFinite(bData)) {
        return Number.isFinite(aData) ? -1 : 1;
      }

      const tierCompare = normalizeTier(a.candidate.service_tier)
        .localeCompare(normalizeTier(b.candidate.service_tier));

      if (tierCompare) return tierCompare;

      return a.candidateIndex - b.candidateIndex;
    }).map((entry) => entry.candidate);
  }

  function fitOptionsListToSeven() {
    const list = document.getElementById('nhip-options');
    if (!list) return;

    const cards = list.querySelectorAll('.nhip-browse-option');
    const previousScrollTop = list.scrollTop;

    list.scrollTop = 0;
    list.style.height = '';

    if (cards.length <= 7) {
      list.scrollTop = previousScrollTop;
      return;
    }

    // Measure the actual text-wrapped rows at this screen width so the eighth
    // row starts below the scroll box instead of appearing partly cut off.
    const seventhBottom = cards[6].getBoundingClientRect().bottom;
    const listTop = list.getBoundingClientRect().top;

    list.style.height = `${Math.ceil(seventhBottom - listTop + 3)}px`;
    list.scrollTop = previousScrollTop;
  }

  function applyPremiumGap(options) {
    return options.map((option) => {
      if (
        normalizeTier(option.service_tier) !== 'PREMIUM' ||
        String(option.plan_type).toUpperCase() !== 'FIXED'
      ) {
        return option;
      }

      const regular = options.find((candidate) =>
        normalizeTier(candidate.service_tier) === 'REGULAR' &&
        String(candidate.plan_type).toUpperCase() === 'FIXED' &&
        Number(candidate.data_gb) === Number(option.data_gb) &&
        parseDays(candidate.validity_label) === parseDays(option.validity_label)
      );

      const regularPrice = Number(regular?.price_usd);
      const premiumPrice = Number(option.price_usd);

      if (
        !regular ||
        !Number.isFinite(regularPrice) ||
        regularPrice <= 0 ||
        !Number.isFinite(premiumPrice)
      ) {
        return option;
      }

      const minimumPremium =
        Math.ceil((regularPrice * 1.2 - 1e-8) * 20) / 20;

      return {
        ...option,
        price_usd: Math.max(premiumPrice, minimumPremium),
        regular_reference_price_usd: regularPrice
      };
    });
  }
    function renderBrowse(data, requested, overrideOptions = null, isFallback = false) {
    const raw = Array.isArray(data.options) ? data.options : [];
    const match = filteredOptions(raw, requested);
    const options = Array.isArray(overrideOptions) ? overrideOptions : match.items;

    if (!options.length) {
      setResult(
        '<p class="nhip-error">We could not find a qualified NHIP eSIM option matching this request.</p>'
      );
      return;
    }

    const requestedDays = validityValue(requested.validity_request);

    const heading = isFallback
      ? `No exact ${requestedDays}-day match — closest longer-validity options`
      : 'Available NHIP™ eSIM Options';

    const rows = options.map((option, index) => {
      const price = Number(option.price_usd);

      const priceHtml = Number.isFinite(price)
        ? `<div class="nhip-card-price">$${price.toFixed(2)}</div>`
        : '';

      const badge = String(option.plan_type || '')
        .toUpperCase()
        .includes('UNLIMITED')
        ? 'Unlimited'
        : 'Fixed Data';

      return `<div class="nhip-card nhip-browse-option" role="radio" tabindex="0" aria-checked="false" data-index="${index}">
        <div class="nhip-card-title-row"><div class="nhip-card-title">${esc(tierLabel(option.service_tier))} · ${esc(customerDataLabel(option))}</div><div class="nhip-card-network"><strong>Networks:</strong> ${esc(option.network_summary || 'Carrier not specified')}</div>${priceHtml}</div>
        <div class="nhip-card-meta">${esc(badge)} · ${esc(option.validity_label || '')}</div>
      </div>`;
    }).join('');

    setResult(`
      <h3>${esc(heading)}</h3>
      <p>${isFallback
        ? `We found ${options.length} qualified alternative${options.length === 1 ? '' : 's'} that meet or exceed your requested ${requestedDays} days.`
        : `We found ${options.length} qualified option${options.length === 1 ? '' : 's'} matching your request.`}</p>
      ${options.length > 3 ? '<p class="nhip-scroll-hint">Scroll inside the box to see more plans.</p>' : ''}
      <div id="nhip-selection-bar" class="nhip-selection-bar"><div id="nhip-selection-status" class="nhip-status">Tap one option to select it.</div><button type="button" id="nhip-continue" class="nhip-btn" disabled>CONTINUE WITH SELECTED PLAN</button></div>
      <div id="nhip-options" role="radiogroup">${rows}</div>
      <div class="nhip-note">Availability and pricing are revalidated before checkout. Supplier identities are never shown.</div>
    `);

    const cards = Array.from(
      document.querySelectorAll('#nhip-options .nhip-browse-option')
    );

    const continueButton = document.getElementById('nhip-continue');
    const selectionStatus = document.getElementById('nhip-selection-status');
    const selectionBar = document.getElementById('nhip-selection-bar');

    let selected = null;

    const choose = (index) => {
      selected = options[index];

      cards.forEach((card, cardIndex) =>
        card.setAttribute('aria-checked', cardIndex === index ? 'true' : 'false')
      );

      if (selectionStatus) {
        selectionStatus.textContent =
          `${tierLabel(selected.service_tier)} · ${customerDataLabel(selected)} · ${selected.validity_label}`;
      }

      if (continueButton) continueButton.disabled = false;

      let selectionBar = document.getElementById('nhip-selection-bar');

      if (!selectionBar) {
        selectionBar = document.createElement('div');
        selectionBar.id = 'nhip-selection-bar';
        selectionBar.className = 'nhip-selection-bar';

        const optionsRoot = document.getElementById('nhip-options');
        optionsRoot?.parentNode?.insertBefore(selectionBar, optionsRoot);

        if (selectionStatus) selectionBar.appendChild(selectionStatus);
        if (continueButton) selectionBar.appendChild(continueButton);
      }

      selectionBar?.classList.add('nhip-show');
    };

    cards.forEach((card, index) => {
      card.addEventListener('click', () => choose(index));

      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose(index);
        }
      });
    });

    continueButton?.addEventListener('click', async () => {
      if (!selected) return;
      await revalidateSelected(selected, requested);
    });

    requestAnimationFrame(fitOptionsListToSeven);
  }

  function placeConfirmedResultAtTop() {
    const root = resultEl();
    const panel = document.querySelector('#nhip-custom-modal .nhip-panel');

    if (!root || !panel) return;

    const head = panel.querySelector('.nhip-head');

    if (head) head.insertAdjacentElement('afterend', root);
    else panel.prepend(root);

    panel.scrollTo({top:0, behavior:'smooth'});
  }

  function renderQuoteResponse(data, selected) {
    if (data.status === 'EXISTING_VARIANT_READY' && data.cart_url) {
      setResult(`<div class="nhip-result nhip-confirmed"><h3>Plan Confirmed</h3><div style="display:flex;align-items:baseline;justify-content:space-between;gap:12px"><p><strong>${esc(tierLabel(selected.service_tier))} · ${esc(customerDataLabel(selected))} · ${esc(selected.validity_label)}</strong></p><p class="nhip-card-price">&#36;${Number(data.quote_price_usd || selected.price_usd).toFixed(2)}</p></div><a class="nhip-btn" style="display:inline-block;text-decoration:none" href="${esc(data.cart_url)}">ADD TO CART</a></div>`);

      placeConfirmedResultAtTop();
      return;
    }

    if (data.quote_available) {
      setResult(`<div class="nhip-result nhip-confirmed"><h3>Plan Confirmed</h3><div style="display:flex;align-items:baseline;justify-content:space-between;gap:12px"><p><strong>${esc(tierLabel(selected.service_tier))} · ${esc(customerDataLabel(selected))} · ${esc(selected.validity_label)}</strong></p><p class="nhip-card-price">&#36;${Number(data.quote_price_usd).toFixed(2)}</p></div><div id="nhip-confirm-bar" class="nhip-confirm-bar"><button type="button" id="nhip-accept" class="nhip-btn">ACCEPT &amp; ADD TO CART</button> <button type="button" id="nhip-back" class="nhip-btn secondary">BACK</button></div><p>This quote is valid for ${esc(data.quote_valid_minutes)} minutes.</p></div>`);

      document.getElementById('nhip-back')?.addEventListener(
        'click',
        () => runSearch()
      );

      document.getElementById('nhip-accept')?.addEventListener(
        'click',
        () => acceptQuote(data, selected)
      );

      placeConfirmedResultAtTop();
      return;
    }

    setResult(`<p class="nhip-error">${esc(data.message || data.reason || 'This plan could not be revalidated. Please search again.')}</p><button type="button" id="nhip-back" class="nhip-btn secondary">BACK TO RESULTS</button>`);

    document.getElementById('nhip-back')?.addEventListener(
      'click',
      () => runSearch()
    );
  }

  function renderExactChoices(choices) {
    if (choices.length === 1) {
      renderQuoteResponse(choices[0].response, choices[0].selected);
      return;
    }

    setResult(`<h3>Available NHIP™ eSIM Options</h3><p>Choose one confirmed plan.</p>${choices.map((choice, index) => `
      <button type="button" class="nhip-card nhip-exact-choice" data-index="${index}" style="display:block;width:100%;text-align:left;font:inherit">
        <span class="nhip-card-title">${esc(tierLabel(choice.selected.service_tier))} · ${esc(customerDataLabel(choice.selected))} · ${esc(choice.selected.validity_label)}</span>
        <span class="nhip-card-price" style="float:right">$${Number(choice.selected.price_usd).toFixed(2)}</span>
      </button>`).join('')}<p class="nhip-note">Select a plan to review it before adding it to the cart.</p>`);

    document.querySelectorAll(
      '#nhip-custom-result .nhip-exact-choice'
    ).forEach((button) => {
      button.addEventListener('click', () => {
        const choice = choices[Number(button.dataset.index)];

        if (choice) renderQuoteResponse(choice.response, choice.selected);
      });
    });
  }

  async function revalidateSelected(selected, requested) {
    setResult('<p><strong>Revalidating your selected plan…</strong></p>');

    const selectedPlanType = quotePlanType(selected);
    const selectedUnlimitedModel = unlimitedModelForOption(selected);
    const selectedDataGb = Number(selected.data_gb);

    const payload = {
      destination: requested.destination,
      country_code: requested.country_code,
      data_request: String(Number.isFinite(selectedDataGb) ? selectedDataGb : 0),
      validity_request: String(parseDays(selected.validity_label)),
      data_gb: Number.isFinite(selectedDataGb) ? selectedDataGb : 0,
      duration_days: parseDays(selected.validity_label),
      plan_type: selectedPlanType,
      unlimited_model: selectedUnlimitedModel,
      service_tier: normalizeTier(selected.service_tier),
      coverage_key: String(selected.offer_key || selected.coverage_key || ''),
      regular_reference_price_usd: Number(selected.regular_reference_price_usd) || 0,
      internal_mode: false,
      customer_email: ''
    };

    try {
      const data = await post(SEARCH_URL, payload);
      renderQuoteResponse(data, selected);
    } catch (error) {
      console.error('NHIP selected-plan revalidation error', error);

      setResult(
        '<p class="nhip-error">We could not revalidate that plan right now. Please try the search again.</p>'
      );
    }
  }

  async function acceptQuote(data, selected) {
    setResult(
      '<p><strong>Validating your quote and preparing your cart…</strong></p>'
    );

    try {
      const selectedPlanType = quotePlanType(selected);
      const selectedUnlimitedModel = unlimitedModelForOption(selected);
      const selectedDataGb = Number(selected.data_gb);

      const payload = {
        destination: requestValues().destination,
        country_code: requestValues().country_code,
        data_gb: Number.isFinite(selectedDataGb) ? selectedDataGb : 0,
        duration_days: parseDays(selected.validity_label),
        plan_type: selectedPlanType,
        unlimited_model: selectedUnlimitedModel,
        service_tier: normalizeTier(selected.service_tier),
        price: data.quote_price_usd,
        token: data.quote_token,
        sig: data.quote_signature,
        issued_at: data.quote_issued_at,
        valid_minutes: data.quote_valid_minutes
      };

      let response;

      try {
        response = await post(ACCEPT_URL, payload);
      } catch (firstError) {
        console.warn(
          'NHIP accept first attempt did not return; retrying once',
          firstError
        );

        setResult(
          '<p><strong>Your plan is still being prepared…</strong><br>Please keep this page open. We are checking the completed cart item now.</p>'
        );

        await new Promise((resolve) => setTimeout(resolve, 2500));
        response = await post(ACCEPT_URL, payload);
      }

      if (response.accepted && response.cart_url) {
        window.location.href = response.cart_url;
        return;
      }

      setResult(
        `<p class="nhip-error">${esc(response.reason || 'This quote needs to be refreshed. Please search again.')}</p>`
      );
    } catch (error) {
      console.error('NHIP accept error', error);

      setResult(
        '<p class="nhip-error">We could not add this quote to the cart after rechecking it. Please request a fresh quote.</p>'
      );
    }
  }

  function buildDiscoveryPayload(requested, planType) {
    const dataNumber = numericValue(requested.data_request);
    const validityNumber = validityValue(requested.validity_request);

    return {
      destination: requested.destination,
      country_code: requested.country_code,
      scope: requested.scope,
      data_request: planType === 'UNLIMITED' ? 'U' : requested.data_request,
      validity_request: requested.validity_request,
      data_gb:
        planType === 'FIXED' && Number.isFinite(dataNumber)
          ? dataNumber
          : '*',
      duration_days: isWildcard(requested.validity_request) ? 0 : validityNumber,
      plan_type: planType,
      unlimited_model: planType === 'UNLIMITED' ? '*' : 'NONE',
      service_tier: requested.service_tier,
      discovery_mode: true,
      internal_mode: false,
      customer_email: ''
    };
  }

  async function runSearch() {
    restoreResultPlacement();

    const requested = requestValues();

    if (!requested.destination || !requested.country_code) {
      setResult('<p class="nhip-error">Please choose a destination.</p>');
      return;
    }

    const dataNumber = numericValue(requested.data_request);
    const validityNumber = validityValue(requested.validity_request);
    const unlimitedRequested = isUnlimitedInput(requested.data_request);

    if (
      !isWildcard(requested.data_request) &&
      !unlimitedRequested &&
      !Number.isFinite(dataNumber)
    ) {
      setResult(
        '<p class="nhip-error">Enter fixed data such as 5 or 10, Unlimited as U / UNL / Unlimited, or * to see all qualified options.</p>'
      );
      return;
    }

    if (!isWildcard(requested.validity_request) && !Number.isFinite(validityNumber)) {
      setResult(
        '<p class="nhip-error">Enter a whole number from 1 to 365 for validity.</p>'
      );
      return;
    }

    setResult(
      '<p><strong>Searching available NHIP connectivity options…</strong></p>'
    );

    const primaryPlanType = unlimitedRequested ? 'UNLIMITED' : 'FIXED';

    try {
      const primaryData = await post(
        SEARCH_URL,
        buildDiscoveryPayload(requested, primaryPlanType)
      );

      const primaryRaw = Array.isArray(primaryData.options)
        ? primaryData.options
        : [];

      const primaryExact = exactOptions(primaryRaw, requested);

      if (primaryExact.length) {
        renderBrowse(primaryData, requested, primaryExact, false);
        return;
      }

      // No exact data + validity match.
      // Only now do we fetch the other plan family for nearby alternatives.
      const secondaryPlanType =
        primaryPlanType === 'FIXED' ? 'UNLIMITED' : 'FIXED';

      let secondaryRaw = [];

      try {
        const secondaryData = await post(
          SEARCH_URL,
          buildDiscoveryPayload(requested, secondaryPlanType)
        );

        secondaryRaw = Array.isArray(secondaryData.options)
          ? secondaryData.options
          : [];
      } catch (secondaryError) {
        console.warn(
          'NHIP nearby-plan secondary-family search error',
          secondaryError
        );
      }

      const nearby = curateNearbyFallback(
        [...primaryRaw, ...secondaryRaw],
        requested,
        7
      );

      if (nearby.length) {
        renderBrowse(primaryData, requested, nearby, true);
        return;
      }

      setResult(
        '<p class="nhip-error">We could not find a qualified NHIP eSIM option that meets or exceeds your requested validity.</p>'
      );
    } catch (error) {
      console.error('NHIP CUSTOM search error', error);

      setResult(
        '<p class="nhip-error">We could not complete the search right now. Please try again.</p>'
      );
    }
  }

  function enableCustomButtons() {
    document.querySelectorAll('a,button').forEach((el) => {
      if (!isCustomTrigger(el)) return;
      setCustomButtonActive(el);
    });
  }

  document.addEventListener('pointerover', (event) => {
    const button = buttonMatch(event.target);

    if (!button) return;

    setCustomButtonActive(button);
  }, true);

  function init() {
    enableCustomButtons();

    const modal = createModal();

    expandProductDestinations();

    const productInfo = document.querySelector(
      'select[name="options[Destination]"]'
    )?.closest('.product__info-container');

    if (productInfo) {
      new MutationObserver(expandProductDestinations).observe(
        productInfo,
        {childList:true, subtree:true}
      );
    }

    window.addEventListener(
      'resize',
      () => requestAnimationFrame(fitOptionsListToSeven)
    );

    document.addEventListener('click', (event) => {
      const button = buttonMatch(event.target);

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      openModal();
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });

    document.getElementById('nhip-custom-close')?.addEventListener(
      'click',
      closeModal
    );

    document.getElementById('nhip-q-cancel')?.addEventListener(
      'click',
      closeModal
    );

    document.getElementById('nhip-q-find')?.addEventListener(
      'click',
      runSearch
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('nhip-open')) {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();